import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import Terminal from "@/pages/Terminal";
import CalendarPage from "@/pages/CalendarPage";
import Leaves from "@/pages/Leaves";
import Reports from "@/pages/Reports";
import Notifications from "@/pages/Notifications";
import AIInsights from "@/pages/AIInsights";
import Security from "@/pages/Security";
import Settings from "@/pages/Settings";
import MyAttendance from "@/pages/MyAttendance";
import PinEntry from "@/pages/PinEntry";
import "@/App.css";

function RoleGuard({ roles, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (!roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function RoleHome() {
  const { user } = useAuth();
  if (!user) return null;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            richColors
            offset={70}
            mobileOffset={{ top: 70, right: 16, bottom: 16, left: 16 }}
            duration={2500}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<RoleHome />} />
              <Route path="/dashboard" element={<RoleGuard roles={["admin", "manager"]}><Dashboard /></RoleGuard>} />
              <Route path="/employees" element={<RoleGuard roles={["admin", "manager"]}><Employees /></RoleGuard>} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/leaves" element={<Leaves />} />
              <Route path="/reports" element={<RoleGuard roles={["admin", "manager"]}><Reports /></RoleGuard>} />
              <Route path="/notifications" element={<RoleGuard roles={["admin", "manager"]}><Notifications /></RoleGuard>} />
              <Route path="/ai-insights" element={<RoleGuard roles={["admin", "manager"]}><AIInsights /></RoleGuard>} />
              <Route path="/security" element={<RoleGuard roles={["admin"]}><Security /></RoleGuard>} />
              <Route path="/settings" element={<RoleGuard roles={["admin"]}><Settings /></RoleGuard>} />
              <Route path="/my-attendance" element={<MyAttendance />} />
            </Route>
            <Route path="/terminal" element={<Terminal />} />
            <Route path="/pin-entry" element={<PinEntry />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
